<template>
    <div class="news">
        <TitlePart text="News" />
        <div class="news-box">
            <p style="text-align: justify">
                Thank You for AsiaCarto 2024! You can see photos of the conference highlights by clicking <a href="https://polyuit-my.sharepoint.com/:f:/g/personal/asiacarto_polyu_edu_hk/Eq5QdoDgQ21Jp_zsC01B_z0BMg-VW8F250DZprp3Uuu5EQ?e=OEBgKC" target="_blank">here</a>.
            </p>
        </div>
        <!-- <a-row :gutter="[24,8]">
            <a-col :xs="24" :lg="16" :xl="18">
                <div class="welcome-box">
                    <p style="text-align:justify;">
                        The International Cartographic Association (<a href="https://icaci.org/" target="_blank">ICA</a>) and The Hong Kong Polytechnic University (<a href="https://www.polyu.edu.hk/en/" target="_blank">PolyU</a>) are pleased to initiate the first regional cartographic conferences (RCC) in Asia, 
                        namely <strong>Asian Cartographic Conference (AsiaCarto 2024)</strong>, that would help to expand and leverage the influence of the ICA in Asia and Pacific region.
                        <br><br>
                        AsiaCarto 2024 will be held during <strong>8-10 December 2024</strong> at <strong>Hong Kong, China</strong>. 
                        The theme is <strong>Cartography and Geospatial AI</strong>.
                        It aims to bring together professionals and those working in related disciplines to offer a platform for discussion, exchange, 
                        and stimulation of research and joined projects on Cartography and GIScience. 
                        In the long run, AsiaCarto aims to evolve into a series of biannual conferences to be held in different Asian countries, 
                        consistently supporting the promotion of Cartography and GIScience, both within Asia and worldwide.
                        <br><br>
                        We are happy to welcome you to AsiaCarto 2024 in Hong Kong!
                    </p>
                </div>
            </a-col>
            <a-col :xs="24"  :lg="8" :xl="6">
                <div class="date-box">
                    <div class="box1">
                        <SoundFilled style="font-size: 1.3rem;color: rgb(22,119,255);margin-right: 10px;"/>
                        <div>
                            <h3>Call For Papers/Abstracts</h3>
                            <p>Paper and abstract submission will start on <b>1 Feb</b> 2024, end on <b>1 Jul</b> 2024. The notifications of acceptance will be sent on <b>20 Jul</b> 2024.</p>
                        </div>
                    </div>
                    <div class="box1">
                        <AlertFilled style="font-size: 1.3rem;color: #DC3545;margin-right: 10px;"/>
                        <div>
                            <h3>Call for Sessions</h3>
                            <p>Submission deadline: <b>1 Apr</b> 2024</p>
                        
                        </div>
                    </div>
                    <div class="box1">
                        <CalendarFilled style="font-size: 1.3rem;color: #35dc35;margin-right: 10px;"/>
                        <div>
                            <h3>Conference Registration</h3>
                            <p>Registration starts: <b>1 Jun</b> 2024<br>Early bird registration: On or before <b>1 Sep</b> 2024</p>
                        </div>
                    </div>
                    <div class="box1">
                        <MessageFilled style="font-size: 1.3rem;color: #87C9C2;margin-right: 10px;"/>
                        <div>
                            <h3>Presenter Registration</h3>
                            <p>Every shortlisted case should appoint its presenter(s) in EasyChair system before <b>10 Oct</b> 2024.</p>
                        </div>
                    </div>
                </div>  
            </a-col>
        </a-row> -->
    </div>
</template>

<script>
import TitlePart from "@/components/TitlePart/TitlePart.vue";
// import { SoundFilled, AlertFilled, CalendarFilled, MessageFilled} from '@ant-design/icons-vue';
export default {
    components: {
        TitlePart,
        // SoundFilled,
        // AlertFilled,
        // CalendarFilled,
        // MessageFilled
    },
};
</script>

<style lang="less" scoped>
@import "./style.less";
</style>